<template lang="pug">

.mute-button(v-on:click="toggle")

  .icon
    headphone-icon.headphone
    ul.volume(v-bind:class="{'active': !isMuted}")
      li.bar
      li.bar
      li.bar

  .cta(v-bind:class="{'active': isMuted || force}")
    div {{ $t('volumeCta') }}

</template>

<script>
// import game from '@/components/game/main.js'
// import MusicService from 'src/api/MusicService'
import listener from 'src/components/game/listener'

import HeadphoneIcon from 'assets/volume/ico-headphone.svg'
import VolumeIcon from 'assets/volume/ico-volume.svg'


export default {
  name: 'mute-button',
  components: {
    HeadphoneIcon,
    VolumeIcon
  },
  props: [

  ],
  data () {
    return {
      isMuted: false,
      force: false
    }
  },
  computed: {

  },
  mounted () {

    setTimeout(()=> {
      this.force = true
      setTimeout(()=> {
        this.force = false
      }, 5000)
    }, 200)
  },
  methods: {
    toggle () {
      this.isMuted = !this.isMuted
      if (this.isMuted) {
        // MusicService.mute()
        listener.setMasterVolume(0)
      } else {
        // MusicService.unmute()
        listener.setMasterVolume(1)
      }
    }
  },
  beforeDestroy () {

  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"

.mute-button
  position: absolute
  top: 0
  right: 0
  pointer-events: all
  width: 50px
  height: 50px


svg
  +center-img()
  max-width: 30px
  max-height: 30px
  fill: white
  stroke: white

.headphone

.volume
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -12%)

  .bar
    display: inline-block
    width: 2px
    height: 8px
    margin: 1px
    background: white
    transform-origin: bottom
    transform: scaleY(0.2)

  &.active
    .bar
      background: $cl-red
      @for $i from 1 through 3
        &:nth-child(#{$i})
          $delay: -0.3s * ($i - 1)
          animation: volume-on 0.5s linear $delay alternate infinite


.cta
  position: absolute
  top: 0
  right: 40px
  height: 50px
  font-size: 0.8rem
  color: white
  white-space: nowrap
  // font-weight: bold
  font-style: italic
  text-align: right
  +flex-center()
  overflow: hidden

  div
    margin-bottom: -10px
    transform: translateX(100%)
    transition: all 0.3s ease 0s
    padding-right: 8px

  &.active
    div
      transform: none



@keyframes volume-on
  to
    transform: scaleY(1)





</style>



// WEBPACK FOOTER //
// MuteButton.vue?f880b39c